<template>
  <div class="accordian--fold">
    <p class="text__bold fold--head flex__between" @click="setToggled">
      <span>{{ item.heading }}:</span>
      <font-awesome-icon v-if="!toggled" icon="chevron-down" class="icon" />
      <font-awesome-icon v-else icon="chevron-down" class="icon" />
    </p>
    <transition name="accordian-open">
      <div v-if="toggled" class="fold--open">
        <simplebar class="fold--overflow" data-simplebar-auto-hide="false">
          <ul class="list__normal fold--content">
            <li v-for="(tip, index) in item.tips" :key="key(index)" v-html="tip"></li>
          </ul>
        </simplebar>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: ["item"],
  data() {
    return {
      toggled: false
    };
  },
  methods: {
    setToggled() {
      return (this.toggled = !this.toggled);
    },
    key(index) {
      return `${this.item.id}-${index}`;
    }
  }
};
</script>

<style scoped lang="scss">
$accordian-height: 200px;
.accordian--fold {
  @include grid($cols: 1, $rows: auto auto, $row-gap: 10px);
  margin-bottom: 10px;
}
.fold--head {
  padding: 5px 10px;
  @include border($color: $dark-grey, $rad: 5px);
  background-color: $grey;
}
.fold--open {
  height: $accordian-height;
  overflow: hidden;
}
.fold--overflow {
  height: $accordian-height;
}
.fold--content {
  padding: 10px;
  background-color: $grey;
  margin-left: 10px;
  border-radius: 5px;
  li {
    padding: 5px;
    list-style-position: outside;
    margin-left: 15px;
  }
}
/*  Transitions  */
.accordian-open-enter {
  height: 0px;
}
.accordian-open-enter-to {
  height: $accordian-height;
  transition: height 0.25s ease-in-out;
}
.accordian-open-leave {
  height: $accordian-height;
}
.accordian-open-leave-to {
  height: 0px;
  transition: height 0.25s ease-in-out;
}
</style>